import React from "react"
import { TableRow, TableRowColumn } from "material-ui"
import { ITimecardPriorPeriodData, ITimecardDay } from "../../../models"
import { grey500, grey800 } from "material-ui/styles/colors"
import strings from "../../../localization/strings"
import * as colorHelper from "../../../helpers/colorHelper"
interface IProps {
	timecardDays: ITimecardDay[],
	differenceTimecard: boolean
	timecardPriorPeriodData: ITimecardPriorPeriodData
}

const EmployeeTimecardExpensesHeaderRow: React.SFC<IProps> = (props: IProps) => {
	const backgroundColor = props.differenceTimecard ? colorHelper.getTimecardPrimaryColor(props.timecardPriorPeriodData) : grey800
	const fontColor = props.differenceTimecard ? colorHelper.getTimecardPrimaryTextColor(props.timecardPriorPeriodData) : grey500
	return (
		<TableRow style={{ height: 10, borderBottom: null }}>
			{props.timecardDays.map((_, i) =>
				<TableRowColumn
					key={i}
					style={{ backgroundColor: backgroundColor, verticalAlign: "top", paddingTop: 5, paddingBottom: 0, fontSize: 10, color: fontColor, height: 10 }}
				>
					{i === 0 &&
						<div>{strings.Expenses.toUpperCase()}</div>
					}
				</TableRowColumn>
			)}
		</TableRow>
	)
}

export default EmployeeTimecardExpensesHeaderRow